// React
import React, { Component } from 'react';
// Redux
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Title from 'components/TitleWithIcon';
import Filtros from './Filtros/index'

const  CambioDePuestoDeEmpadronamientoParaUsuarios= (props)=> {

    return (
        <div style={{backgroundColor:'white', width:"100%", height:"80%"}}>
            <Title title={'Cambio de lugar de empadronamiento'} icon={"/menu/PerfilUsuario.png"}/>
            <Filtros />
        </div>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(CambioDePuestoDeEmpadronamientoParaUsuarios);